import React from 'react'

const DownloadIcon2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fill='currentColor'
      d='M7.35417 10.963L3.1875 6.79629L4.35417 5.58795L6.52083 7.75462V0.962952H8.1875V7.75462L10.3542 5.58795L11.5208 6.79629L7.35417 10.963ZM2.35417 14.2963C1.89583 14.2963 1.50347 14.1331 1.17708 13.8067C0.850694 13.4803 0.6875 13.088 0.6875 12.6296V10.1296H2.35417V12.6296H12.3542V10.1296H14.0208V12.6296C14.0208 13.088 13.8576 13.4803 13.5312 13.8067C13.2049 14.1331 12.8125 14.2963 12.3542 14.2963H2.35417Z'
    />
  </svg>
)

export default DownloadIcon2
